import { useCallback, useState } from 'react';

import httpApi from 'hooks/api/httpApi';

import { useTranslation } from 'react-i18next';

import SnackbarUtils from 'utils/SnackbarUtils';

import DeliveryMode from '../models/DeliveryMode';

import RefundForm from '../models/RefundForm';

const useSubmitForm = (callback?: VoidFunction) => {
    const [loading, setLoading] = useState<boolean>(false);

    const { t } = useTranslation('refund');

    const handleSubmit = useCallback(
        async (values: RefundForm): Promise<void> => {
            setLoading(true);

            const body = {
                package_parameters: values.package_parameters,
                products: values.products.map((product) => ({
                    SourceNo: product.SourceNo,
                    description: product.description,
                    documentNo: product.documentNo,
                    documentType: product.documentType,
                    itemNo: product.itemNo,
                    quantity: product.quantity,
                    unitOfMeasureCode: product.unitOfMeasureCode,
                })),
                reason: {
                    id: values.reason.id,
                    text: values.reason.text,
                },
            };

            switch (values.mode) {
                case DeliveryMode.COURIER_SERVICE:
                    body['courier_service'] = {
                        delivery_address: {
                            ...values.courier_service.delivery_address,
                            postcode:
                                +values.courier_service.delivery_address
                                    .postcode,
                        },
                        end_time: values.courier_service.end_time,
                        start_time: values.courier_service.start_time,
                    };
                    break;
                case DeliveryMode.TRANSIT:
                    body['transit'] = {
                        delivery_address: {
                            ...values.transit.delivery_address,
                            postcode: +values.transit.delivery_address.postcode,
                        },
                        end_time: values.transit.end_time,
                        start_time: values.transit.start_time,
                    };
                    break;
                case DeliveryMode.PICKUP_POINT:
                    body['pickup_point'] = {
                        store_location_id:
                            values.pickup_point.store_location_id,
                        phone: values.pickup_point.phone,
                    };
                    break;
            }

            httpApi
                .post('api/v1/products-return', body)
                .then((): void => {
                    SnackbarUtils.success(t('SUCCESS_MESSAGE'));
                    callback?.();
                })
                .finally(() => setLoading(false));
        },
        [t]
    );

    return {
        handleSubmit,
        loading,
    };
};

export default useSubmitForm;
